import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import ReactPhoneInput, { getCountryCallingCode } from 'react-phone-number-input';
import Input from '../Input/Input.component.js';
import Dropdown from '../Dropdown/Dropdown.component.js';
import { propTypes, defaultProps } from './PhoneInput.types.js';
import styles from './PhoneInput.module.scss.js';

var CountrySelect = /** @class */ (function (_super) {
    __extends(CountrySelect, _super);
    function CountrySelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.countryCodeLabel = function (code) {
            if (!code) {
                return 'International';
            }
            return code + " +" + getCountryCallingCode(code);
        };
        _this.getFlagUrl = function (code) {
            if (!code) {
                return null;
            }
            return "https://purecatamphetamine.github.io/country-flag-icons/3x2/" + code + ".svg";
        };
        _this.handleCountryChange = function (_a) {
            var _b, _c;
            var value = _a.value;
            _this.props.setCountry &&
                _this.props.setCountry({ selectedCountry: value });
            (_c = (_b = _this.props).onChange) === null || _c === void 0 ? void 0 : _c.call(_b, value);
        };
        _this.render = function () {
            var _a = _this.props, value = _a.value, disabled = _a.disabled, options = _a.options, testId = _a.testId, label = _a.label;
            var props = _this.props.countryCodeDropdownProps || {};
            var flagUrl = _this.getFlagUrl(value);
            var customOptions = options === null || options === void 0 ? void 0 : options.reduce(function (acc, option) {
                if (option.value) {
                    acc.push({
                        label: _this.countryCodeLabel(option.value),
                        value: option.value,
                    });
                }
                return acc;
            }, []);
            var dropdownValue = customOptions === null || customOptions === void 0 ? void 0 : customOptions.find(function (option) { return option.value === value; });
            return (React__default.createElement("div", { className: styles.CountrySelect },
                React__default.createElement(Dropdown, __assign({ className: styles.CountryDropdown, controlClassName: styles.CountryDropdown_control, isDisabled: disabled, options: customOptions, value: dropdownValue, onChange: _this.handleCountryChange, withDividers: false, "data-testid": (_this.props['data-testid'] || testId) &&
                        (_this.props['data-testid'] || testId) + "CountryCodeDropdown", label: label }, props)),
                flagUrl && (React__default.createElement("img", { src: flagUrl, className: styles.CountryFlag }))));
        };
        return _this;
    }
    CountrySelect.prototype.componentDidMount = function () {
        if (this.props.relativelyStyledConditions) {
            console.warn('DEPRECATION WARNING: Use isMultilineSecondaryCondition instead. `relativelyStyledConditions` is scheduled to be removed in the next major release');
        }
    };
    return CountrySelect;
}(React__default.Component));
var NumberInput = /** @class */ (function (_super) {
    __extends(NumberInput, _super);
    function NumberInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleOnChange = function (event) {
            var _a, _b;
            if (event.target.value === '') {
                _this.props.onClear();
            }
            else {
                (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, event);
            }
        };
        _this.render = function () {
            var _a = _this.props, inputRef = _a.inputRef, label = _a.label, className = _a.className, variant = _a.variant, isValid = _a.isValid, errorMessage = _a.errorMessage, clearable = _a.clearable, primaryCondition = _a.primaryCondition, secondaryCondition = _a.secondaryCondition, onFocus = _a.onFocus, onBlur = _a.onBlur, testId = _a.testId, value = _a.value, disabled = _a.disabled, isMultilineSecondaryCondition = _a.isMultilineSecondaryCondition, placeholder = _a.placeholder, _b = _a.phoneNumberInputProps, phoneNumberInputProps = _b === void 0 ? {} : _b;
            return (React__default.createElement(Input, __assign({ inputRef: inputRef, label: label, className: clsx(styles.NumberInput, className), variant: variant, isValid: isValid, errorMessage: errorMessage, clearable: clearable, primaryCondition: primaryCondition, secondaryCondition: secondaryCondition, "data-testid": (_this.props['data-testid'] || testId) &&
                    (_this.props['data-testid'] || testId) + "NumberInput", onChange: _this.handleOnChange, onFocus: onFocus, onBlur: onBlur, value: value, disabled: disabled, isMultilineSecondaryCondition: isMultilineSecondaryCondition, placeholder: placeholder }, phoneNumberInputProps)));
        };
        return _this;
    }
    return NumberInput;
}(React__default.Component));
// TODO: missing typings for react-phone-number-input inputComponent
var NumberInputWithRef = React__default.forwardRef(function (props, inputRef) { return React__default.createElement(NumberInput, __assign({}, props, { inputRef: inputRef })); });
var PhoneInput = /** @class */ (function (_super) {
    __extends(PhoneInput, _super);
    function PhoneInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedCountry: _this.props.defaultCountry,
        };
        _this.handleClear = function () {
            var _a, _b;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, undefined);
        };
        return _this;
    }
    PhoneInput.prototype.componentDidMount = function () {
        if (this.props.testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
    };
    PhoneInput.prototype.render = function () {
        var _a = this.props, testId = _a.testId, value = _a.value, variant = _a.variant, label = _a.label, countryLabel = _a.countryLabel, numberLabel = _a.numberLabel, name = _a.name, isValid = _a.isValid, errorMessage = _a.errorMessage, className = _a.className, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, disabled = _a.disabled, clearable = _a.clearable, primaryCondition = _a.primaryCondition, secondaryCondition = _a.secondaryCondition, relativelyStyledConditions = _a.relativelyStyledConditions, placeholder = _a.placeholder, phoneNumberInputProps = _a.phoneNumberInputProps, countryCodeDropdownProps = _a.countryCodeDropdownProps;
        var isMultilineSecondaryCondition = this.props.isMultilineSecondaryCondition;
        isMultilineSecondaryCondition =
            isMultilineSecondaryCondition || relativelyStyledConditions;
        return (React__default.createElement(ReactPhoneInput, { defaultCountry: this.state.selectedCountry, international: false, displayInitialValueAsLocalNumber: true, limitMaxLength: true, value: value || '', onChange: onChange, onFocus: onFocus, onBlur: onBlur, disabled: disabled, className: clsx(styles.PhoneInput, isMultilineSecondaryCondition &&
                styles.PhoneInput___multilineConditions, className), name: name, countrySelectComponent: CountrySelect, countrySelectProps: {
                label: countryLabel,
                testId: this.props['data-testid'] || testId,
                setCountry: this.setState.bind(this),
                countryCodeDropdownProps: countryCodeDropdownProps,
            }, inputComponent: NumberInputWithRef, numberInputProps: {
                label: numberLabel !== null && numberLabel !== void 0 ? numberLabel : label,
                className: className,
                variant: variant,
                isValid: isValid,
                errorMessage: errorMessage,
                clearable: clearable,
                primaryCondition: primaryCondition,
                secondaryCondition: secondaryCondition,
                testId: this.props['data-testid'] || testId,
                value: value,
                onClear: this.handleClear,
                onFocus: onFocus,
                onBlur: onBlur,
                disabled: disabled,
                isMultilineSecondaryCondition: isMultilineSecondaryCondition,
                placeholder: placeholder,
                phoneNumberInputProps: phoneNumberInputProps,
            } }));
    };
    PhoneInput.displayName = 'PhoneInput';
    PhoneInput.propTypes = propTypes;
    PhoneInput.defaultProps = __assign({}, defaultProps);
    return PhoneInput;
}(React__default.Component));

export { PhoneInput as default };
